import { RoundData } from './types';

export const exportToCSV = (rounds: RoundData[]): string => {
  const headers = [
    'Round',
    'Grid Size',
    'Flip Back Delay (ms)',
    'Preview Time (ms)',
    'Hints Enabled',
    'Image Similarity Level',
    'Correct Pairs',
    'Total Attempts',
    'Errors',
    'Total Time (ms)',
    'Average Reaction Time (ms)',
    'Accuracy (%)',
    'Timestamp'
  ].join(',');

  const rows = rounds.map(round => [
    round.roundNumber,
    `${round.gridSize.rows}x${round.gridSize.cols}`,
    round.flipBackDelay,
    round.previewTime,
    round.hintsEnabled,
    round.imageSimilarityLevel,
    round.correctPairs,
    round.totalAttempts,
    round.errors,
    round.totalTime,
    round.averageReactionTime,
    (round.accuracy * 100).toFixed(2),
    round.timestamp
  ].join(','));

  return [headers, ...rows].join('\n');
};

export const downloadData = (rounds: RoundData[], format: 'csv' | 'json') => {
  const data = format === 'csv' ? exportToCSV(rounds) : JSON.stringify(rounds, null, 2);
  const blob = new Blob([data], { type: format === 'csv' ? 'text/csv' : 'application/json' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `matching-grid-results.${format}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};